var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c(_vm.tag,_vm._b({tag:"component",staticClass:"overlay-title"},'component',_vm.props,false),[_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.tag != 'div')?_c('font-awesome-icon',{attrs:{"icon":{prefix: 'fa', iconName: 'chevron-right'}}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }